import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import BatchEditOrDeleteConfirmation from '../../../modals/BatchEditOrDeleteConfirmation';
import { BatchEditAttributeName } from '../../../types/batchActions';
import { BatchAction } from '../../../types/store';
import { getAttributeParamsForBatchAction } from './utils';

export interface Props {
  batchAction: BatchAction;
  selectedCount: number;
  cancelBatchAction: () => void;
  onSave: (attrName: BatchEditAttributeName, attrValue: boolean) => void;
}

const AttributeBatchEdit: FC<Props> = ({
  batchAction,
  selectedCount,
  cancelBatchAction,
  onSave,
}) => {
  const { attrName, attrValue } = useMemo(
    () => getAttributeParamsForBatchAction(batchAction),
    [batchAction]
  );
  const handleSave = useCallback(
    () => attrName && onSave(attrName, attrValue),
    [attrName, attrValue, onSave]
  );

  return (
    <BatchEditOrDeleteConfirmation
      isOpen
      selectedCount={selectedCount}
      onConfirm={handleSave}
      onCancel={cancelBatchAction}
    />
  );
};
AttributeBatchEdit.displayName = 'AttributeBatchEdit';

export default AttributeBatchEdit;
